import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./RegisterPage.css";

const API_BASE = process.env.REACT_APP_API_BASE ;

export default function RegisterPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    password: "",
    phone: "",
  });
  // Confirm password local state
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleConfirmChange = (e) => {
    setConfirmPassword(e.target.value);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE}/auth/register/`, form);

      // store tokens
      localStorage.setItem("access", res.data.access);
      localStorage.setItem("refresh", res.data.refresh);

      navigate("/login");

    } catch (err) {
      setError(
        err.response?.data?.detail ||
        err.response?.data?.username ||
        "Signup failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-bg">
      <div className="register-header-gradient"/>
      <div className="register-main-card">
        <div className="register-card-left">
          <h2>Signup</h2>
          <form onSubmit={handleSubmit} className="register-form" autoComplete="off">
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                className="register-input"
                id="username"
                name="username"
                placeholder="Enter username"
                onChange={handleChange}
                required
                autoComplete="username"
              />
            </div>
            <div className="input-group">
              <label htmlFor="phone">Phone</label>
              <input
                className="register-input"
                id="phone"
                name="phone"
                placeholder="Enter phone"
                onChange={handleChange}
                autoComplete="tel"
              />
            </div>
            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                className="register-input"
                id="password"
                name="password"
                type="password"
                placeholder="Enter password"
                onChange={handleChange}
                required
                autoComplete="new-password"
              />
            </div>
            <div className="input-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                className="register-input"
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={handleConfirmChange}
                required
                autoComplete="new-password"
              />
            </div>
            {error && <div className="register-error">{error}</div>}
            <button
              className="register-btn"
              disabled={loading}
              type="submit"
            >
              {loading ? "Creating..." : "Signup"}
            </button>
          </form>
          <div className="register-link">
            Already have account?{" "}
            <Link to="/login" className="register-login-link">Login</Link>
          </div>
        </div>
        <div className="register-card-right">
          <h1>WELCOME!</h1>
          <p>
           
          </p>
        </div>
      </div>
    </div>
  );
}